import settings from "../../../../constants/settings";
import { useCallback } from "react";
import { useCustomAlert } from "../../alerts";
import useFetchAndTrace from "../../fetchWithTrace";

export default function useDownloadPartPickList() {
  const customAlert = useCustomAlert();
  const fetchAndTrace = useFetchAndTrace();

  const errorHandler = useCallback(() => {
    customAlert("Failed to get pick list");
  }, [customAlert]);

  return useCallback(
    (boardId: string, boardProjectName: string, shipmentId: string | null) => {
      const getPickListHandler = async (response: Response) => {
        if (response.ok) {
          const blob = await response.blob();
          const link = document.createElement("a");
          link.download = `${boardProjectName}-${boardId}-picklist.xlsx`;
          link.href = URL.createObjectURL(blob);
          link.click();
        } else {
          throw Error("Failed to get pick list");
        }
      };
      if (shipmentId === null) {
        return null;
      }
      void fetchAndTrace(
        `${settings.api_url}/boards/${boardId}/shipments/${shipmentId}/part-pick-list`,
        getPickListHandler,
        errorHandler,
      );
    },
    [errorHandler, fetchAndTrace],
  );
}
